let ctx: AudioContext | null = null;

const getCtx = (): AudioContext | null => {
  if (typeof window === "undefined") {
    return null;
  }

  if (!ctx) {
    const AudioContextClass =
      window.AudioContext || (window as any).webkitAudioContext;

    if (!AudioContextClass) {
      return null;
    }

    try {
      ctx = new AudioContextClass();
    } catch {
      return null;
    }
  }

  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }

  return ctx;
};

const beep = (
  freq: number,
  durationMs: number,
  volume = 0.35,
  type: OscillatorType = "triangle",
) => {
  const audioCtx = getCtx();
  if (!audioCtx) {
    return;
  }

  try {
    const oscillator = audioCtx.createOscillator();
    const gain = audioCtx.createGain();

    oscillator.type = type;
    oscillator.frequency.value = freq;

    const now = audioCtx.currentTime;
    const dur = durationMs / 1000;
    const attack = 0.008;

    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.linearRampToValueAtTime(volume, now + attack);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + dur);

    oscillator.connect(gain);
    gain.connect(audioCtx.destination);

    oscillator.start(now);
    oscillator.stop(now + dur + 0.02);
  } catch {
    // ignore audio errors — kiosk should never break because of feedback
  }
};

export const beepSuccess = () => {
  beep(1047, 90, 0.35);
  setTimeout(() => beep(1319, 90, 0.35), 95);
  setTimeout(() => beep(1568, 160, 0.4), 190);
};

export const beepError = () => {
  beep(392, 200, 0.4);
  setTimeout(() => beep(311, 280, 0.4), 220);
};

export const beepDrop = () => {
  beep(500, 70, 0.22);
};
